.root {
  display: flex;
  gap: 8px;
  min-width: 0;
  width: 100%;
}

.country-select {
  flex: 0 0 172px;
}

.phone-input {
  flex: 1;
  min-width: 0;
}

.country-option {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  min-width: 0;
  width: 100%;
}

.calling-code {
  color: var(--color-muted);
  flex-shrink: 0;
}

@media (max-width: 520px) {
  .root {
    flex-direction: column;
  }

  .country-select {
    flex-basis: auto;
  }
}
